// ---------------------------------------
// ---------------------------------------
//
// *** Warning ***
//
// ALL VARIABLES HERE ARE NOT PRIVATE
// 
// ---------------------------------------
// ---------------------------------------


// Production variables
// -------------------------

const production = {
    SERVER_API_URL: 'https://api.smecapadvisory.com',
    CLIENT_URL: 'https://smecapadvisory.com.au',
    TESTING_FUNCTIONS: false,
};


// Development variables
// -------------------------

const development = {
    SERVER_API_URL: 'https://dev-api.smecapadvisory.com.au',
    CLIENT_URL: 'https://dev.smecapadvisory.com.au',
    TESTING_FUNCTIONS: true
}


// Development variables
// -------------------------

const local = {
    SERVER_API_URL: 'http://localhost:3090',
    CLIENT_URL: 'http://localhost:3000',
    TESTING_FUNCTIONS: true,
}


const url = new URL(window.location.href);
const parts = url.hostname.split('.');
const subdomain = parts.length > 2 ? parts[0] : '';

export const config = process.env.NODE_ENV === 'development' ? local : subdomain === 'dev' ? development : production;